import { render, staticRenderFns } from "./cantina-roberto-voerzio.vue?vue&type=template&id=cfe2c89a&scoped=true"
import script from "./cantina-roberto-voerzio.vue?vue&type=script&lang=js"
export * from "./cantina-roberto-voerzio.vue?vue&type=script&lang=js"
import style0 from "./cantina-roberto-voerzio.vue?vue&type=style&index=0&id=cfe2c89a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe2c89a",
  null
  
)

export default component.exports